import React, { useEffect, useState } from "react";
import { AudioLines, Volume2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import PageHeader from "@/components/PageHeader";
import { useLang } from "@/context/LangContext";
import api from "@/lib/api";

export default function AudioLogs() {
  const { t } = useLang();
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/readaloud-logs").then(({ data }) => setLogs(data)); }, []);

  const getContext = () => ({ total: logs.length, byLang: logs.reduce((a, l) => { a[l.language] = (a[l.language] || 0) + 1; return a; }, {}),
    screens: [...new Set(logs.map((l) => l.screen))] });

  return (
    <div className="space-y-6 fade-up" data-testid="audio-logs-page">
      <PageHeader title={t("audio_logs")} subtitle={t("audio_logs_desc")} screen="audio-logs" getContext={getContext} />
      <Card className="rounded-2xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/60 text-xs uppercase tracking-wider text-muted-foreground">
              <tr>
                <th className="text-start font-semibold px-4 py-3">{t("screen")}</th>
                <th className="text-start font-semibold px-4 py-3 hidden sm:table-cell">{t("role")}</th>
                <th className="text-start font-semibold px-4 py-3">{t("language")}</th>
                <th className="text-start font-semibold px-4 py-3">{t("duration")}</th>
                <th className="text-start font-semibold px-4 py-3 hidden md:table-cell">Time</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l, i) => (
                <tr key={i} className="border-t" data-testid={`audio-log-${i}`}>
                  <td className="px-4 py-3 font-medium flex items-center gap-2"><Volume2 className="h-4 w-4 text-primary" />{l.screen}</td>
                  <td className="px-4 py-3 capitalize text-muted-foreground hidden sm:table-cell">{(l.user_role || "").replace("_", " ")}</td>
                  <td className="px-4 py-3"><span className="rounded-full bg-secondary px-2 py-0.5 text-xs font-semibold uppercase">{l.language}</span></td>
                  <td className="px-4 py-3">{l.duration ? `${l.duration.toFixed(1)}s` : "-"}</td>
                  <td className="px-4 py-3 text-muted-foreground hidden md:table-cell">{new Date(l.timestamp).toLocaleString()}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-muted-foreground"><AudioLines className="h-8 w-8 mx-auto mb-2 opacity-40" />No audio summaries logged yet. Use the 🔊 control on any screen.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
